<template>
    <AntTable
        :columns="itemColumns"
        :data-source="items"
        :pagination="{
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
        }"
        row-key="id"
    >
        <template
            #expandedRowRender="{ responseOptions }"
        >
            <AntTable
                row-key="id"
                :pagination="false"
                :columns="responseColumns"
                :data-source="orderBy(responseOptions, 'itemScore')"
            />
        </template>
    </AntTable>
</template>

<script>
import { table } from 'ant-design-vue';
import orderBy from 'lodash/orderBy';

export default {
    components: {
        AntTable: table,
    },
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            itemColumns: [
                { title: this.$t('rank'), dataIndex: 'order', key: 'order' },
                { title: this.$t('code'), dataIndex: 'code', key: 'code' },
                { title: this.$t('preStem'), dataIndex: 'stem.preStem', key: 'stem.preStem' },
                { title: this.$t('stem'), dataIndex: 'stem.stem', key: 'stem.stem' },
                { title: this.$t('postStem'), dataIndex: 'stem.postStem', key: 'stem.postStem' },
            ],
            responseColumns: [
                { title: this.$t('label'), dataIndex: 'label', key: 'label' },
                { title: this.$t('score'), dataIndex: 'itemScore', key: 'score' },
                { title: this.$t('rank'), dataIndex: 'order', key: 'order' },
                { title: this.$t('isCustomAnswer'), dataIndex: 'isCustomAnswer', key: 'isCustomAnswer', customRender: value => this.$t(value ? 'yes' : 'no') },
            ],
        };
    },
    methods: {
        orderBy,
    },
};
</script>

<style>

</style>